import { ref, Ref } from 'vue'

// Code adapted from
// https://stackoverflow.com/questions/16057256/draw-on-a-canvas-via-mouse-and-touch
// https://stackoverflow.com/questions/17130395/real-mouse-position-in-canvas
export function useCanvas(canvas: Ref<HTMLCanvasElement | null>) {
  const canvasValue = ref('')

  function resetCanvas() {
    if (canvas.value) {
      const context = canvas.value.getContext('2d')!
      context.clearRect(0, 0, canvas.value.width, canvas.value.height)
    }
  }

  function setupCanvas() {
    if (canvas.value) {
      const context = canvas.value.getContext('2d')!
      let isIdle = true
      function drawstart(event: MouseEvent | Touch) {
        const { x, y } = getMousePos(event)
        context.beginPath()
        context.moveTo(x, y)
        isIdle = false
      }
      function drawmove(event: MouseEvent | Touch) {
        if (isIdle) return
        const { x, y } = getMousePos(event)
        context.lineTo(x, y)
        context.stroke()
      }
      function drawend(event: MouseEvent | Touch) {
        getData()
        if (isIdle) return
        drawmove(event)
        isIdle = true
      }
      function touchstart(event: TouchEvent) {
        event.touches
        drawstart(event.touches[0])
      }
      function touchmove(event: TouchEvent) {
        drawmove(event.touches[0])
        event.preventDefault()
      }
      function touchend(event: TouchEvent) {
        drawend(event.changedTouches[0])
      }

      canvas.value.addEventListener('touchstart', touchstart, false)
      canvas.value.addEventListener('touchmove', touchmove, false)
      canvas.value.addEventListener('touchend', touchend, false)

      canvas.value.addEventListener('mousedown', drawstart, false)
      canvas.value.addEventListener('mousemove', drawmove, false)
      canvas.value.addEventListener('mouseup', drawend, false)
    }
  }

  function getData() {
    if (canvas.value) {
      canvasValue.value = canvas.value.toDataURL()
    }
  }

  function getMousePos(event: MouseEvent | Touch) {
    const rect = canvas.value!.getBoundingClientRect()
    const scaleX = canvas.value!.width / rect.width // relationship bitmap vs. element for x
    const scaleY = canvas.value!.height / rect.height // relationship bitmap vs. element for y
    return {
      x: (event.clientX - rect.left) * scaleX,
      y: (event.clientY - rect.top) * scaleY,
    }
  }

  return { setupCanvas, getData, canvasValue, resetCanvas }
}
